import React, { FC, useContext } from 'react';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { saveItem } from '@/utils';
import { STORAGE_KEY_GHOST_MODE, STORAGE_KEY_HIDDEN_MODE } from '@/constants/storage';
import { HiddenContext } from '@/providers/HiddenProvider';
import { GhostContext } from '@/providers/GhostProvider';
import useStyles from './styles';

const HiddenChange: FC = () => {
  const classes = useStyles();

  const { isHiddenMode, setIsHiddenMode } = useContext(HiddenContext);
  const { setIsGhostMode } = useContext(GhostContext);

  return (
    <FormControlLabel
      control={(
        <Switch
          checked={isHiddenMode}
          onChange={handleChange}
          name="checkedB"
          color="primary"
        />
            )}
      className={classes.text}
      label="Confidential Publisher View (CPV)"
    />
  );

  function handleChange() {
    const hidden = !isHiddenMode;
    setIsHiddenMode(hidden);
    setIsGhostMode(hidden);
    saveItem(STORAGE_KEY_HIDDEN_MODE, String(hidden));
    saveItem(STORAGE_KEY_GHOST_MODE, String(hidden));
  }
};

export default HiddenChange;
